import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeZoomed } from '../../../actions/SpendingReportActions';
import { ApplicationState } from '../../../reducers/Index';
import { SpendingReportState, FilterState,UserState } from '../../../interface/MyInterfaces';
import { EmployeeChart } from './EmployeeChart';
import { EmployeeAgencyChart } from './EmployeeAgencyChart';
import MapContainer from "../../Common/MapContainer";
import { isAgg } from '../../Common/Helpers';

interface zoomed_props {
    SpendingReportState?: SpendingReportState;
    FilterState?: FilterState;
    closeZoomed?();
    UserState?: UserState;
    agg?: any;
}

class Zoomed extends React.Component<zoomed_props, {}> {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }
    handleClose() {
        this.props.closeZoomed();
    }
    public render() {
        const agg = isAgg(this.props.UserState.report_display_id);
        const showZoomed = this.props.SpendingReportState.showZoomed;
        const isMapZoom = [3, 4, 5, 6, 9].includes(showZoomed);
        return <Modal
            show={(showZoomed > 0)}
            onHide={this.handleClose}
            animation={false}
            dialogClassName={isMapZoom ? "ZoomModal ZoomModal--map" : "ZoomModal"}
            >
            <Modal.Header style={isMapZoom ? { paddingBottom: 0, borderBottom: "none" } : { paddingBottom: "30px" }}>
                <span title="Close" className="close-button" style={{ zIndex: 99 }}><i className="fa fa-window-close fa-3x" onClick={this.handleClose}></i></span>
            </Modal.Header>
            <Modal.Body style={isMapZoom ? { padding: "0 24px 16px" } : { padding: "30px" }}>


                {this.props.SpendingReportState.showZoomed == 1 &&
                    <EmployeeChart
                        refresh_className={"fa fa-2x fa-refresh refreshlarge"}
                        normal_or_large={1} SpendingEmployeeChart={this.props.SpendingReportState.SpendingEmployeeChart}
                        FilterState={this.props.FilterState}
                        agg={0}
                        SpendingEmployeeChart_Data={this.props.SpendingReportState.SpendingEmployeeChart_Data}
                        SpendingEmployeeChart_Years={this.props.SpendingReportState.SpendingEmployeeChart_Years}
                        SpendingReport_Tab1={this.props.SpendingReportState.SpendingReport_Tab1}
                    />
                }
                {this.props.SpendingReportState.showZoomed == 2 &&
                    <EmployeeAgencyChart
                        normal_or_large={1}
                        SpendingEmployeeAgencyChart={this.props.SpendingReportState.SpendingEmployeeAgencyChart}
                        FilterState={this.props.FilterState}
                        agg={0}
                        report_display_id={this.props.UserState.report_display_id}
                        SpendingEmployeeAgencyChart_Data={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data}
                        SpendingReport_Tab1={this.props.SpendingReportState.SpendingReport_Tab1}
                    />}
                {
                    (this.props.SpendingReportState.showZoomed == 3) &&
                    <MapContainer
                        isCongress={false}
                        isInState={false}
                        isZoomed={true}
                        state_fips={this.props.SpendingReportState.SpendingReportConf.state_fips}
                        mapData={this.props.SpendingReportState.SpendingExpenditureMap}
                        USState={this.props.SpendingReportState.USStateList}
                        agg={agg}

                    />
                }

                {
                    (this.props.SpendingReportState.showZoomed == 4) &&
                    <MapContainer
                        isCongress={false}
                        isInState={true}
                        isZoomed={true}
                        state_fips={this.props.SpendingReportState.SpendingReportConf.state_fips}
                        mapData={this.props.SpendingReportState.SpendingExpenditureMap}
                        USState={this.props.SpendingReportState.USStateList}
                        agg={agg}
                    />
                }
                {
                    (this.props.SpendingReportState.showZoomed == 5) &&
                    <MapContainer
                        isInState={false}
                        isZoomed={true}
                        isCongress={true}
                        state_fips={this.props.SpendingReportState.SpendingReportConf.state_fips}
                        mapData={this.props.SpendingReportState.SpendingCongressMap}
                        USState={this.props.SpendingReportState.USStateList}
                        agg={agg}

                    />
                }

                {
                    (this.props.SpendingReportState.showZoomed == 6) &&
                    <MapContainer
                        isInState={true}
                        isZoomed={true}
                        isCongress={true}
                        state_fips={this.props.SpendingReportState.SpendingReportConf.state_fips}
                        mapData={this.props.SpendingReportState.SpendingCongressMap}
                        USState={this.props.SpendingReportState.USStateList}
                        agg={agg}
                    />
                }


                {this.props.SpendingReportState.showZoomed == 7 &&
                    <EmployeeChart
                        refresh_className={"fa fa-2x fa-refresh refreshlarge"}
                        normal_or_large={1} SpendingEmployeeChart={this.props.SpendingReportState.SpendingEmployeeChart_Aggregate}
                        FilterState={this.props.FilterState}
                        agg={1}
                        SpendingEmployeeChart_Data={this.props.SpendingReportState.SpendingEmployeeChart_Data_Agg}
                        SpendingEmployeeChart_Years={this.props.SpendingReportState.SpendingEmployeeChart_Years_Agg}
                        SpendingReport_Tab1={this.props.SpendingReportState.SpendingReport_AggTab}
                    />
                }
                {this.props.SpendingReportState.showZoomed == 8 &&
                    <EmployeeAgencyChart
                        normal_or_large={1}
                        SpendingEmployeeAgencyChart_Data={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data_Agg}
                        SpendingReport_Tab1={this.props.SpendingReportState.SpendingReport_AggTab}
                        SpendingEmployeeAgencyChart={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Aggregate}
                        FilterState={this.props.FilterState}
                        agg={1} />
                }

                {this.props.SpendingReportState.showZoomed == 9 &&
                    <MapContainer
                        isInState={false}
                        isZoomed={true}
                        isCongress={false}
                        state_fips={this.props.SpendingReportState.SpendingReportConf.state_fips}
                        mapData={this.props.SpendingReportState.SpendingExpenditureMap_Aggregate}
                        USState={this.props.SpendingReportState.USStateList}
                        agg={agg}
                    />
                }
            
         </Modal.Body>
        </Modal>
    }
}


const mapStateToProps = (state: ApplicationState) => ({
    SpendingReportState: state.spendingReportProperties,
    FilterState: state.filterProperties,
    UserState: state.userProperties,
});


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        { closeZoomed: closeZoomed }, dispatch
    )
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(Zoomed);